import { render, staticRenderFns } from "./SearchBox.vue?vue&type=template&id=636bb5de"
import script from "./SearchBox.vue?vue&type=script&lang=js"
export * from "./SearchBox.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SearchBox.vue?vue&type=style&index=0&id=636bb5de&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports